import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianDepartmentFieldController extends GeneralTreatingPhysicianFieldController {}
